import { PaymentMethod } from "@/enums/tenancies/PaymentMethod";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";

export class TenancyHelper {
  // generate the day of month description with ordinal suffix
  static generateDayOfMonthDescription(day: number): string {
    switch (day) {
      case 0:
        return "Not Specified";
      case 1:
      case 21:
      case 31:
        return `${day} st`;
      case 2:
      case 22:
        return `${day} nd`;
      case 3:
      case 23:
        return `${day} rd`;
      default:
        return `${day} th`;
    }
  }

  // Returns an array of strings suitable for dropdown options
  static populateDays(): IDDescriptionPair[] {
    const days: IDDescriptionPair[] = [];
    for (let i = 1; i <= 31; i++) {
      days.push({ id: i, description: this.generateDayOfMonthDescription(i) });
    }
    days.push({ id: 32, description: "Start of Each Period" });
    days.push({ id: 33, description: "End of Each Period" });
    return days;
  }

  static calcTax(decGross: number, decRate: number): number {
    return Math.round((decGross / (100 + decRate)) * decRate * 100) / 100;
  }

  static camelToTitleCase(key: string): string {
    return key.replace(/([A-Z])/g, " $1").trim();
  }

  static paymentMethods: IDDescriptionPair[] = Object.entries(PaymentMethod)
    .filter(([, value]) => typeof value === "number")
    .map(([key, value]) => ({
      id: value as number,
      description: TenancyHelper.camelToTitleCase(key),
    }));
}
